import React, { useState, useContext } from "react";
import { ViewContext } from "../Context/ViewContext";

export function ViewManager() {
	const { currentView } = useContext(ViewContext);

	return <>{currentView}</>;
}
